import { render, staticRenderFns } from "./batchDropBrand.vue?vue&type=template&id=1c174e96&scoped=true&"
import script from "./batchDropBrand.vue?vue&type=script&lang=js&"
export * from "./batchDropBrand.vue?vue&type=script&lang=js&"
import style0 from "./batchDropBrand.vue?vue&type=style&index=0&id=1c174e96&lang=stylus&scoped=true&"
import style1 from "./batchDropBrand.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c174e96",
  null
  
)

export default component.exports